import { FC } from 'react'
import { default as MuiContainer, ContainerProps as MuiContainerProps } from '@mui/system/Container'

type MaxWidth = 'sm' | 'md' | 'lg' | 'xl'

export type ContainerProps = Pick<
  MuiContainerProps,
  'disableGutters' | 'fixed' | 'ref' | 'children' | 'id' | 'key' | 'sx'
> & { maxWidth?: MaxWidth; 'data-testid'?: string }

/**
 * The container centers your content horizontally. It's the most basic layout element.
 *
 * More info can be found at: https://mui.com/material-ui/react-container
 */

export const Container: FC<ContainerProps> = props => {
  return <MuiContainer {...props} />
}
